import { Injectable } from "@angular/core";
import { TradeKey } from "../../core/model/api";

@Injectable({
  providedIn: 'root'
})
export class KeysHelper {

  resolveKeyName(key: TradeKey) {
    return key.name || this.maskKeyToken(key)
  }

  maskKeyToken(key: TradeKey) {
    return key.authData.publicKey.substring(0, 5) + '***'
  }

}